<template>
	<div id="tripchimp-page">
		<header class="text-center">
			<h1 class="oomph text-4xl">
				TRIP TEMPLEIT
			</h1>
			<p>Fyrir mailchimp</p>
		</header>
		
		<section class="mx-auto flex mt-12 max-w-5xl">
			<div class="input w-2/3 flex flex-wrap pr-12">
				<TextField label="Linkur" name="url" v-model="url"/>
				<TextField label="Mynd" name="image" v-model="image" @click="addImage"/>
				<TextField label="Borg" name="city" v-model="city"/>
				<TextField label="Land" name="country" v-model="country"/>
				<TextField label="Hótel" name="hotel" v-model="hotel"/>
				<TextField label="Stjörnur" name="stars" type="number" v-model="stars"/>
				<TextField label="Herbergi" name="room" v-model="room"/>
				<TextField label="Fæði" name="mealplan" v-model="mealplan"/>
				<TextField label="Frá flugvelli" name="origin" v-model="origin"/>
				<TextField label="Til flugvallar" name="destination" v-model="destination"/>
				<TextField label="Frá dagsetningu" name="from" type="date" v-model="outbound"/>
				<TextField label="Til dagsetningar" name="to" type="date" v-model="inbound"/>
				<TextField label="Fullorðnir" name="adults" type="number" v-model.number="adults"/>
				<TextField label="Börn" name="children" type="number" v-model.number="children"/>
				<TextField label="Verð per farþega" name="price" v-model.number="price"/>
			</div>
			<div class="output w-1/3 pt-12">
				<div class="max-w-xs">
					<h2 class="text-center font-bold text-xl pb-4">Preview:</h2>
					<div v-html="template"/>


					<div class="copy mt-12 text-center">
						<Button text="Kópíra kubb" @click="onClick"/>
					</div>
				</div>

			</div>
		</section>
	</div>
</template>

<script lang="ts">
import isk from '@/functions/isk'
import simpleDateRange from '@/functions/simpleDateRange'
import isMatch from 'date-fns/isMatch'
import useCloudinaryMediaLibrary from '#/useCloudinaryMediaLibrary'

import { format } from 'date-fns'
import { defineComponent, computed, ref, watch, watchEffect } from 'vue'
import { unixTime, repeatString, copyToClipboard } from '@/modules/Geri'

import Button      from '@@/gui/Button.vue'
import { TextField } from '@@/gui/fields'

export default defineComponent({
	name: 'TripChimpPage',

	components: {
		Button,
		TextField
	},

	setup () {
		const url         = ref<string>('')
		const city        = ref<string>('')
		const country     = ref<string>('')
		const hotel       = ref<string>('')
		const stars       = ref<number>(3)
		const room        = ref<string>('')
		const mealplan    = ref<string>('')
		const outbound    = ref<string>('')
		const inbound     = ref<string>('')
		const price       = ref<string>('0')
		const adults      = ref<number>(1)
		const children    = ref<number>(0)
		const origin      = ref<string>('KEF')
		const destination = ref<string>('')
		const image       = ref<string>('')

		function updateDate (date: string) {
			return isMatch(date, 'yyyy-MM-dd') ? new Date(date) : new Date()
		}
		const outDate = computed<Date>(() => updateDate(outbound.value))
		const inDate  = computed<Date>(() => updateDate(inbound.value))

		const widget = useCloudinaryMediaLibrary(image)

		watchEffect(() => console.log(city.value))
		
		function addImage () {
			widget.show()
		}
		function formatDate (date: Date) {
			return format(date, 'dd.MM.yyyy')
		}
		function onClick () {
			copyToClipboard(template.value)
			alert('Kubbur kópíraður!')
		}

		const template = computed<string>(() => {
			const repeatIcon = ''

			return `
			<a href="${url.value}" 
				style="display: block; 
					text-decoration: none; 
					height:530px; 
					font-family: 'DIN Next LT Pro', 'Helvetica Neue', Arial, sans-serif !important; 
					padding: 8px;
					font-stretch: condensed;"
			>
				<table style="background:#fff; width: 100%; color: #000; ">
					<tbody>
						<tr>
							<td style="font-size: 24px; 
								color: #fff; 
								font-weight: bolder; 
								text-transform: uppercase;
								text-shadow: 2px 1px 4px #666;"
							>
								<div style="padding-top: 200px; background-color: #ccc; background-size: cover; background-image: url(${image.value});">
									<div style="padding: 0 12px;">${city.value}</div>
									<div style="padding: 0 12px 12px;">${simpleDateRange([ outDate.value, inDate.value ])}</div>
								</div>
							</td>
						</tr>
						<tr>
							<td style="padding: 12px; text-transform: uppercase; font-stretch: condensed; line-height: 1.5em;">
								<div>
									<span style="font-weight: bold;">
										${hotel.value} ${stars.value}★
									</span>
									<br/>
									${city.value} / ${country.value}
									<br/>
									<img style="height: 20px; width: auto; display: inline-block;" src="https://hermes.fitravel.info/airplane.png"/> ${origin.value} — ${destination.value}
									<br/>
									${formatDate(outDate.value)} - ${formatDate(inDate.value)}
									<br/>
									${room.value}
									<br/>
									${mealplan.value}
									<br/>
									<span style="color: #f3000c; font-weight: bolder; padding: 6px 0; font-size: 21px;">
										${isk(parseInt(price.value))} á mann*
									</span>
									<br/>
									M.V. ${repeatString(
										'<img style="height: 30px; width: auto; display: inline-block;" src="https://hermes.fitravel.info/adult.png"/>'
									)(adults.value)}${repeatString(
										'<img style="height: 30px; width: auto; display: inline-block;" src="https://hermes.fitravel.info/child.png"/>'
									)(children.value)}
								</div>
								<div style="text-align: right;">
									<span style="display: inline-block; background: #f3000c; color: #fff; padding: 8px 12px; border-radius: 10px;">
										BÓKAÐU HÉR
									<span>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</a>
		`
		})

		return {
			url,
			template,
			city,
			country,
			hotel,
			stars,
			room,
			mealplan,
			outbound,
			inbound,
			price,
			adults,
			children,
			origin,
			destination,
			addImage,
			image,
			onClick
		}
	}
})
</script>

<style scoped>
.input ::v-deep .text-field {
	@apply block flex-initial px-3 flex pb-0;
}
.input ::v-deep .text-field .label {
	@apply font-bold w-1/2 py-2 px-4 bg-black text-white;
}
.input ::v-deep .text-field .input {
	@apply rounded-l-none;
}
/*#tripchimp-page {
	max-width: 50rem;
	margin: 0 auto;
	padding: 1rem;

	header {
		width: 100%;
		font-weight: bold;
		color: rgba(254, 254, 254, .6);
		text-align: center;
		padding: 3rem 0;

		h1 {
			padding: 0;
		}
		p {
			padding-top: 12px;
			text-transform: uppercase;
		}
	}
	h2 {
		text-align: center;
		font-size: 1rem;
		text-transform: uppercase;
		font-weight: bolder;
		color: rgba(254, 254, 254, .6);
		padding-bottom: 1rem;
	}
	footer {
		position: relative;
		text-align: center;
		padding: 1rem 0 3rem;

		.copy {
			button {
				padding: 12px;
				background: green;
				color: #fff;
				text-transform: uppercase;
				font-size: 1rem;
				box-shadow: 0 0 5px rgba(0, 0, 0, .33);
				font-weight: bolder;
				border: none;

				&:hover {
					background: darkolivegreen;
					cursor: pointer;
				}
			}
		}
	}
	

	.cloudinary {
		button {
			width: 100%;
			padding: 6px;
			margin-bottom: 24px;
			text-transform: uppercase;
			font-size: 1rem;
			font-weight: bolder;
			background: darkblue;
			color: white;
			border: none;
			box-shadow: 0 0 5px rgba(0,0,0,.33);

			&:hover {
				background: darkslategray;
				cursor: pointer;
			}
		}
	}

	/deep/ .text-input {
		border-bottom: 1px solid black;
		padding: 0;
		margin: 0;
		width: 100%;

		label {
			text-transform: uppercase;
			border-right: 1px solid black;
			color: #000;
			width: 38%;
			padding: 13px 6px 0 12px;
			background: #eee;
		}
		.field {
			input {
				font-size: 1rem;
				font-family: 'Courier New', Courier, monospace;
				background: white;
				box-shadow: none;
				padding: 12px;
				margin: 0;
				width: 58%;
				color: #000;

				&:focus {
					outline: none;
				}
			}
		}
	}

	@media screen and (min-width: 600px) {
		> section {
			display: grid;
			grid-gap: 4rem;
			grid-template-columns: 66% 33%;

			.input {
				//flex: 3 0 auto;
			}
		}

		/deep/ .text-input {
			display: flex;

			label, .field {
				flex: 1 0 auto;
			}
		}
	}	

	h1 {
		font-size: 3rem;
		padding: 2rem 0;
	}

	.column {
	}
}*/
</style>